import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReview: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReview"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM13.3225 10.1797L12 7L10.6775 10.1797L7.24472 10.4549L9.86012 12.6953L9.06107 16.0451L12 14.25L14.9389 16.0451L14.1399 12.6953L16.7553 10.4549L13.3225 10.1797Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReview;
